import type { TOC } from '@ember/component/template-only';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

const SettingsLoadingRouteTemplate: TOC<object> = <template>
	<SkeletonScreenComponent @type="table" />
</template>;

export default SettingsLoadingRouteTemplate;
